import React from "react";
import './footer.styles.css'

export default function Footer() {
    return (
        <div className="ui shbg-pallet footer-bg sh-footer vertical segment footer segment no-radius" id="footerMainDiv">
            <div className="ui grid container">
                <div className="row">
                    <div className="eight wide mobile four wide tablet four wide computer column">
                        <div className="ui small header">
                            CALL
                        </div>
                        <div className="ui link list">
                            <div className="item">
                                <span id="footerPhoneNumber">(+91) 74474 77868</span>
                            </div>
                        </div>
                        <div className="ui hidden divider hide-on-computer"></div>
                    </div>
                    <div className="eight wide mobile four wide tablet four wide computer column">
                        <div className="ui small header">
                            EMAIL
                        </div>
                        <div className="ui link list">
                            <div className="item">
                                <a href="mailto:info@cctech.co.in">
                                    info@cctech.co.in
                                </a>
                            </div>
                        </div>
                        <div className="ui hidden divider hide-on-computer"></div>
                    </div>
                    <div className="eight wide mobile four wide tablet four wide computer column">
                        <div className="ui small header">
                            FOLLOW US
                        </div>
                        <div className="spaced">
                            <a className="ui facebook tiny icon button no-radius" target="_blank" rel="noreferrer" href="https://www.facebook.com/cctechindia">
                                <i className="facebook f icon"></i>
                            </a>
                            <a className="ui twitter tiny icon button no-radius" target="_blank" rel="noreferrer" href="https://twitter.com/cctech_india">
                                <i className="twitter icon"></i>
                            </a>
                            <a className="ui google plus tiny icon button no-radius" target="_blank" rel="noreferrer" href="https://plus.google.com/+CCTechPuneIndia/">
                                <i className="google plus icon"></i>
                            </a>
                            <a className="ui linkedin tiny icon button no-radius" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/centre-for-compuational-technologies-cctech">
                                <i className="linkedin icon"></i>
                            </a>
                            <a className="ui youtube tiny icon button no-radius" target="_blank" rel="noreferrer" href="https://www.youtube.com/CCTechIndia">
                                <i className="youtube play icon"></i>
                            </a>
                        </div>
                        <div className="ui hidden divider hide-on-computer"></div>
                    </div>
                    <div className="eight wide mobile four wide tablet four wide computer column">
                        <div className="ui small header">
                            VISIT
                        </div>
                        <div className="ui link list">
                            <div className="item">
                                <div className="container-limit max-width-500">
                                    <a target="_blank" rel="noreferrer" href="https://goo.gl/maps/8r6CyDWkook35VDA8">
                                        403, Pushpak Business Hub, Wakad, Pune 411057, India
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ui grey divider"></div>
            </div>
        </div>
    )
}